//@flow
import React from 'react';
import {Link} from 'react-router-dom';

import SwitchableSection from '../../../../../elements/SwitchableSection';
import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {useStoreReviews} from '../../../../marketing/reviews/utils';
import {colors} from '../../../../../assets/styles/colors';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  disabledRoot: {
    background: colors.grey300,
  },
  caption: {
    color: colors.grey700,
    fontSize: '1rem',
    marginBottom: '1rem',
    display: 'block',
  },
}));

type Props = {
  sectionEnabled?: boolean,
};

export default function OrderReviews(props: Props) {
  const {sectionEnabled} = props;

  const classes = useStyles();
  const reviews = useStoreReviews();

  const emptyContent = !reviews || !reviews.some(r => r.enabled && r.featured);

  return (
    <SwitchableSection
      id={HOME_PAGE_SECTION_NAMES.ORDER_REVIEWS}
      title="Sección Reseñas"
      subtitle="Promueve tus ventas con el uso de las reseñas de cliente. No hay mejor recomendación que la de un cliente satisfecho."
      classes={{
        root: emptyContent || !sectionEnabled ? classes.disabledRoot : '',
      }}
    >
      {emptyContent && (
        <span className={classes.caption}>
          *No hay reseñas destacadas configuradas. Puedes destacar reseñas
          existentes usando la estrella en la sección de reseñas.
        </span>
      )}
      <CustomButton
        variant="contained"
        component={Link}
        to="/marketing/reviews"
        target="_blank"
        rel="noopener noreferrer"
      >
        Configurar reseñas
      </CustomButton>
    </SwitchableSection>
  );
}
